import { render, staticRenderFns } from "./StoreHomepage.vue?vue&type=template&id=35e34030&scoped=true&"
import script from "./StoreHomepage.vue?vue&type=script&lang=js&"
export * from "./StoreHomepage.vue?vue&type=script&lang=js&"
import style0 from "./StoreHomepage.vue?vue&type=style&index=0&id=35e34030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e34030",
  null
  
)

export default component.exports